import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { SpamNumberModel, Permission } from '@/types';
import { applyPhoneMask } from '@/utils/number';
import { PencilAltIcon, CheckCircleIcon, XCircleIcon } from '@heroicons/vue/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpamNumberListItem',
  props: {
    modelValue: {
        type: Object as PropType<SpamNumberModel>,
        required: true,
    },
},
  emits: ['activate', 'inactivate'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;
const handleActivateClick = () => emit('activate', __props.modelValue);
const handleInactivateClick = () => emit('inactivate', __props.modelValue);

const __returned__ = { emit, handleActivateClick, handleInactivateClick, get Permission() { return Permission }, get applyPhoneMask() { return applyPhoneMask }, get PencilAltIcon() { return PencilAltIcon }, get CheckCircleIcon() { return CheckCircleIcon }, get XCircleIcon() { return XCircleIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})